"use client";

import React from "react";
import dynamic from "next/dynamic";
import { HeroSection } from "./marketing/2026/mist-hero";

// Dynamically import below-the-fold sections to code-split the JS bundle
const Features = dynamic(() => import("./marketing/2026/Features"));
const FeaturesSection = dynamic(() => import("./marketing/2026/FeaturesSection"), { ssr: false });
const Integrations = dynamic(() => import("./marketing/2026/Integrations"));
const FAQ = dynamic(() => import("./marketing/2026/FAQ"), { ssr: false });
const Pricing = dynamic(() => import("./marketing/2026/Pricing"));
const CTA = dynamic(() => import("./marketing/2026/CTA"));
const Footer = dynamic(() => import("./marketing/2026/Footer"));

export function LandingPage() {
  return (
    <>
      <HeroSection />

      <Features />
      <FeaturesSection />
      <Integrations />
      <FAQ />
      <div className="bg-accent">
        <Pricing />
      </div>
      <CTA />
      <Footer />
    </>
  );
}
